import React, { Fragment, createContext, useEffect, useRef, useState } from 'react';
import { Convert, Extension, FnAxios, FnDialog, I18n, } from "utilities/utilities";
import { ApiLeave } from "enum/api";
import { APIStatusCode, EnumLeaveTypeID, EnumSaveModeLeave, EnumLeaveStatus, I18NextNs, EnumLogHistoryMode } from 'enum/enum';
import { useLocation, useNavigate } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';
import LogHistory from './components/LogHistory';
import StepFlow from './components/StepFlow';
import { Grid, Typography } from '@mui/material';
import { BtnBack, BtnReject, BtnSave, BtnSend } from 'components/Button/ButtonAll';
import moment from 'moment';
import { RadioListItem } from 'components/Input/Radio';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { TextAreaItem } from 'components/Input/TextArea';
import { TextBoxItem } from 'components/Input/TextBox';
import UploadFileItem from 'components/Input/UploadFile';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { Moment } from 'moment';

const LeaveContext = createContext(null);
const LeaveFrom = () => {
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const location = useLocation();
    const DialogFn = FnDialog();

    const form = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sLeaveType: 1,
            dLeaveStartDate: null, //new Date(),
            sLeaveTypeStart: 1,
            dLeaveEndDate: null,
            sLeaveTypeEnd: null,
            sAddress: null,
            sTelNo: null,
            sDescription: null,
        } as any,
    });

    //#region useState
    const [isPermission, setPermission] = useState<boolean>(false); // Permission true = Edit | false = View, Disabled
    const [nLeaveID, setnLeaveID] = useState(0);
    const [sMode, setsMode] = useState(null);
    const [nStatusID, setnStatusID] = useState(null);
    const [isUserReques, setisUserReques] = useState(true);
    const [isUserAdmin, setisUserAdmin] = useState(false);
    const [isError, setisError] = useState(false);
    const [isGetFromID, setisGetFromID] = useState(false);

    const currentDate = new Date(); // Get the current date
    const _dStart = new Date(currentDate.getFullYear(), 0, 1); //01/01/New
    const _dEnd = new Date(currentDate.getFullYear(), 12, 0); //31/12/New
    // const isBtnCancel = ((nStatusID === EnumLeaveStatus.Recall_D1 || nStatusID === EnumLeaveStatus.Recall_D2) ? false : form.watch("dLeaveStartDate") < currentDate);
    const [isBtnCancel, setisBtnCancel] = useState(false);
    // const isBtnCancel = ((nStatusID === EnumLeaveStatus.Recall_D1 || nStatusID === EnumLeaveStatus.Recall_D2) ? false : Convert.DateTimeToString(form.watch("dLeaveStartDate"), "YYYY-MM-DD") < Convert.DateTimeToString(moment(currentDate).format("YYYY-MM-DD"), "YYYY-MM-DD"));
    //console.log("dLeaveStartDate Convert", Convert.DateTimeToString(form.watch("dLeaveStartDate"), "YYYY-MM-DD"));
    //console.log("currentDate Convert", Convert.DateTimeToString(moment(currentDate).format("YYYY-MM-DD"), "YYYY-MM-DD"));
    //console.log("Data ", Convert.DateTimeToString(form.watch("dLeaveStartDate"), "YYYY-MM-DD") < Convert.DateTimeToString(currentDate.getDate() + "", "YYYY-MM-DD"));
    //console.log("currentDate", moment(currentDate).format("DD/MM/YYYY"));

    const [sDate, setsDate] = useState(moment(currentDate).format("DD/MM/") + ((+currentDate.getFullYear()) + 543));
    const [nUserID, setnUserID] = useState(null);
    const [sUser, setsUser] = useState(null);

    const [nCalculateDay, setnCalculateDay] = useState(0);
    const [nSickLeave, setnSickLeave] = useState(null);
    const [nVacationLeave, setnVacationLeave] = useState(null);

    //#region Approver
    const [ObjApprover, setObjApprover] = useState(null);
    // const [ObjApprover, setObjApprover] = useState({
    //     isNotApprovePart: true, //กรณีเช็คว่ามี StepFlow ผอ.ส่วน ไหม (True มี | False ไม่มี)
    //     isPart: false, //ผอ.ส่วน
    //     isPile: false, //ผอ.กอง
    //     arrUserApprove_1: [],
    //     arrUserApprove_2: [],
    // });

    // const [isNotApprovePart, setisNotApprovePart] = useState<boolean>(true); //กรณีเช็คว่ามี StepFlow ผอ.ส่วน ไหม (True มี | False ไม่มี)
    // const [isPart, setisPart] = useState<boolean>(false); //ผอ.ส่วน
    // const [isPile, setisPile] = useState<boolean>(false); //ผอ.กอง
    // const [arrUserPartID, setarrUserPartID] = useState<any>([]);
    // const [arrUserPileID, setarrUserPileID] = useState<any>([]);
    const [nApproverD1_PositionID, setnApproverD1_PositionID] = useState(0); //ผอ.ส่วน
    const [nApproverD2_PositionID, setnApproverD2_PositionID] = useState(0); //ผอ.กอง
    //#endregion

    const onClearImportFile = useRef(null);
    const [arrFileRequest, setarrFileRequest] = useState<any>([]);
    const [isFileRequired, setisFileRequired] = useState(false);

    const [arrHoliday, setarrHoliday] = useState<any>([]);
    const [arrLeaveTypeID, setarrLeaveTypeID] = useState<any>([]);
    const [arrPeriodTypeStartID, setarrPeriodTypeStartID] = useState<any>([]);
    const [arrPeriodTypeEndID, setarrPeriodTypeEndID] = useState<any>([]);

    const [isUserActing_D1, setisUserActing_D1] = useState(false);
    const [isUserActing_D2, setisUserActing_D2] = useState(false);

    const [isErrorDuplicationType, setisErrorDuplicationType] = useState(false);
    //#endregion

    useEffect(() => {
        let nID = 0;
        if(location?.state){
            nID = +location.state["sID"];
            let sMode = location.state["sMode"]; //View | null | Edit ต้องจับจากสถานะ
            setnLeaveID(nID);
            setsMode(sMode);
            setPermission(sMode !== "View");
        } else {
            GetMenuPermission(AxiosFn, setPermission, DialogFn);
        }
        GetFormInitialLeave(nID);
    }, []);

    useEffect(() => {
        if (isGetFromID && nLeaveID != 0) {
            handleGetFormLeaveID(nLeaveID);
        }
    }, [nLeaveID, isGetFromID]);

    const GetFormInitialLeave = (nID) => {
        AxiosFn.Get(ApiLeave.GetFormInitialLeave, {nLeaveID : nID}, (result) => {
            setisError(false);

            setsDate(result.sStartDate);
            setnUserID(result.nUserID);
            setsUser(result.sUserName);
            setarrHoliday((result.lstHolidayDate ?? []).map(m => moment(new Date(m))));
            setarrLeaveTypeID(result.lstLeaveTypeID);
            setarrPeriodTypeStartID(result.lstPeriodTypeStartID);
            setarrPeriodTypeEndID(result.lstPeriodTypeEndID);
            form.setValue("sAddress", result.sAddress);
            form.setValue("sTelNo", result.sTelNo);

            //#region Approver
            // setisNotApprovePart(result.isNotApprovePart);
            // setisPart(result.isPart);
            // setarrUserPartID(result.lstUserApprovePartID);
            // setisPile(result.isPile);
            // setarrUserPileID(result.lstUserApprovePileID);

            setnApproverD1_PositionID(result.nApproverD1_PositionID);
            setnApproverD2_PositionID(result.nApproverD2_PositionID);
            setisUserActing_D1(result.isPart); //ผอ.ส่วน
            setisUserActing_D2(result.isPile); //ผอ.กอง
            setObjApprover({
                isNotApprovePart: result.isNotApprovePart, //กรณีเช็คว่ามี StepFlow ผอ.ส่วน ไหม (True มี | False ไม่มี)
                isPart: result.isPart, //ผอ.ส่วน ( True ไม่อยู่ใช้รักษาการ | False ผอ.ส่วน อยู่ )
                isPile: result.isPile, //ผอ.กอง ( True ไม่อยู่ใช้รักษาการ | False ผอ.กอง อยู่ )
                arrUserApprove_1: result.lstUserApprovePartID,
                arrUserApprove_2: result.lstUserApprovePileID,
                nApproverD1_PositionID: result.nApproverD1_PositionID,
                // nApproverD2_PositionID: result.nApproverD2_PositionID,
            });
            //#endregion

            setnSickLeave(result.nSickLeave ?? 0);
            setnVacationLeave(result.nVacationLeave ?? 0);
            setisUserReques(result.isUserReques);
            setisUserAdmin(result.isUserAdmin);
            setisBtnCancel(result.isBtnCancel_UserReques);
            if(nID) setisGetFromID(true); //handleGetFormLeaveID(nID);

            if (result.isNotApprovePart && result.lstUserApprovePartID.length === 0) {
                setisError(true);
                return DialogFn.Warning("กรุณาตรวจสอบข้อมูลผู้อนุมัติ ในตำแหน่ง ผอ.ส่วน/ผอ.ฝ่าย");
            }
            if (result.lstUserApprovePileID.length === 0) {
                setisError(true);
                return DialogFn.Warning("กรุณาตรวจสอบข้อมูลผู้อนุมัติ ในตำแหน่ง ผอ.กอง");
            }
        });
    }

    useEffect(() => {
        if (nSickLeave != null && nVacationLeave != null && nStatusID !== EnumLeaveStatus.Canceled && sMode !== "View") CalLeaveDate();
    }, [nStatusID, nSickLeave, nVacationLeave, form.watch("sLeaveType"), form.watch("dLeaveStartDate"), form.watch("dLeaveEndDate"), form.watch("sLeaveTypeStart"), form.watch("sLeaveTypeEnd")])

    const CalLeaveDate = () => {
        let ObjData = form.getValues();
        let ObjLeaveType = ObjData.sLeaveType;
        let dStart = ObjData.dLeaveStartDate;
        let dEnd = ObjData.dLeaveEndDate;
        if ((dStart && dEnd) || dStart)  //(dStart && Convert.StringToInt(ObjLeaveType) === EnumLeaveTypeID.VacationLeave)
        {
            if (dStart && dEnd) {
                let sStart = Convert.DateTimeToString(dStart, "YYYY-MM-DD")
                let sEnd = Convert.DateTimeToString(dEnd, "YYYY-MM-DD")
                if (sStart >= sEnd) {
                    form.setValue("dLeaveEndDate", null);
                    form.setValue("sLeaveTypeEnd", null);
                    return;
                }
            }

            //#region Old Upload File
            // //Upload File จะ Require Field ก็ต่อเมื่อ เลือกประเภทการลาป่วย เท่ากับหรือมากกว่า 3 วัน ระบบจะบังคับแนบเอกสาร (อาจจะเป็นใบรับรองแพทย์ที่ต้องแนบเข้า
            // let ObjLeaveType = ObjData.sLeaveType;
            // if (Convert.StringToInt(ObjLeaveType) === EnumLeaveTypeID.SickLeave)
            // {
            //    dStart = moment(dStart);
            //    dEnd = moment(dEnd);
            //    let difDay = dEnd.diff(dStart, 'days')
            //    if (difDay >= 3) {
            //     setisFileRequired(true);
            //    } else {
            //     setisFileRequired(false);
            //    }
            // } else {
            //    setisFileRequired(false);
            // }
            //#endregion

            let param = {
                nLeaveID: nLeaveID,
                nUserID: nUserID,
                nLeaveTypeID: ObjData.sLeaveType,
                nLeaveStartDate: ObjData.dLeaveStartDate ? ObjData.dLeaveStartDate.valueOf() : 0,
                nStartLeaveTimeID: ObjData.sLeaveTypeStart,
                nLeaveEndDate: ObjData.dLeaveEndDate ? ObjData.dLeaveEndDate.valueOf() : (ObjData.dLeaveStartDate ? ObjData.dLeaveStartDate.valueOf() : 0),
                nEndLeaveTimeID: ObjData.sLeaveTypeEnd,
                nCalculateDay: nCalculateDay,
                nSickLeave: nSickLeave,
                nVacationLeave: nVacationLeave,
            };
            AxiosFn.Post(ApiLeave.CalculateLeaveDate, param, (result) => {
                setnCalculateDay(result.objResult.nCalculateDay); //จำนวณวันลาทั้งหมด

                //#region Upload File จะ Require Field ก็ต่อเมื่อ เลือกประเภทการลาป่วย
                if (Convert.StringToInt(ObjLeaveType) === EnumLeaveTypeID.SickLeave)
                {
                    let sDataStart = Convert.DateTimeToString(dStart, "YYYY-MM-DD");
                    let sDataNew = Convert.DateTimeToString(currentDate + "", "YYYY-MM-DD");
                    if (sDataStart > sDataNew) { //กรณีเลือกลาป่วยล่วงหน้า ให้ Require เอกสารแนบ
                        setisFileRequired(true);
                    }
                    else if (result.objResult.nCalculateDay >= 3) { //เท่ากับหรือมากกว่า 3 วัน ระบบจะบังคับแนบเอกสาร (อาจจะเป็นใบรับรองแพทย์ที่ต้องแนบเข้า)
                        setisFileRequired(true);
                    } else {
                        setisFileRequired(false);
                    }
                } else {
                    setisFileRequired(false);
                }
                //#endregion

                if (result.nStatusCode !== APIStatusCode.Success) {
                    // DialogFn.Warning(result.sMessage);
                    // setisError(true);

                    //แบบเลือกแค่วันเดียว
                    let Duplication_sMode = result.objResult.sMode;
                    if (Duplication_sMode)
                    {
                        setisError(false);
                        let isTime = result.objResult.isTime;  //True = เช้า | False = บ่าย
                        let isDate = result.objResult.isDate; // Start = true | End = false

                        switch (Duplication_sMode) {
                            case "A":
                                let nStartLeaveTimeID = result.objResult.nStartLeaveTimeID;
                                if (isDate)
                                {
                                    let lstPeriodTypeStartID_A = arrPeriodTypeStartID;
                                    lstPeriodTypeStartID_A.forEach(e => {
                                        if(e.value === 1 || e.value === nStartLeaveTimeID){
                                            e.disabled = true;
                                        }else{
                                            e.disabled = false;
                                        }
                                    });
                                    setarrPeriodTypeStartID([...lstPeriodTypeStartID_A]);
                                    form.setValue("sLeaveTypeStart", (isTime ? nStartLeaveTimeID + 1 : nStartLeaveTimeID - 1));
                                    setisErrorDuplicationType(isTime === false);
                                }
                                else if (!isDate)
                                {
                                    let lstPeriodTypeEndID_A = arrPeriodTypeEndID;
                                    lstPeriodTypeEndID_A.forEach(e => {
                                        if(e.value === 1 || e.value === nStartLeaveTimeID){
                                            e.disabled = true;
                                        }else{
                                            e.disabled = false;
                                        }
                                    });
                                    setarrPeriodTypeEndID([...lstPeriodTypeEndID_A]);
                                    form.setValue("sLeaveTypeEnd", (isTime ? nStartLeaveTimeID + 1 : nStartLeaveTimeID - 1));
                                }
                                if (result.objResult.nCalculateDay === 0.5) DialogFn.Warning(result.sMessage);
                                break;
                            case "B":
                                let nStartLeaveTimeID_ = result.objResult.nStartLeaveTimeID;
                                if (isDate)
                                {
                                    let lstPeriodTypeStartID_B = arrPeriodTypeStartID;
                                    lstPeriodTypeStartID_B.forEach(e => {
                                        if(e.value === 1 || e.value === nStartLeaveTimeID_){
                                            e.disabled = true;
                                        }else{
                                            e.disabled = false;
                                        }
                                    });
                                    setarrPeriodTypeStartID([...lstPeriodTypeStartID_B]);
                                    form.setValue("sLeaveTypeStart", (isTime ? nStartLeaveTimeID_ + 1 : nStartLeaveTimeID_ - 1));
                                    setisErrorDuplicationType(isTime === false);
                                }
                                else if (!isDate)
                                {
                                    let lstPeriodTypeEndID_B = arrPeriodTypeEndID;
                                    lstPeriodTypeEndID_B.forEach(e => {
                                        if(e.value === 1 || e.value === nStartLeaveTimeID_){
                                            e.disabled = true;
                                        }else{
                                            e.disabled = false;
                                        }
                                    });
                                    setarrPeriodTypeEndID([...lstPeriodTypeEndID_B]);
                                    form.setValue("sLeaveTypeEnd", (isTime ? nStartLeaveTimeID_ + 1 : nStartLeaveTimeID_ - 1));
                                }
                                if(result.objResult.nCalculateDay === 0.5) DialogFn.Warning(result.sMessage);
                                break;
                            case "C":
                                let nEndLeaveTimeID = result.objResult.nEndLeaveTimeID;
                                if (isDate)
                                {
                                    let lstPeriodTypeStartID_C = arrPeriodTypeStartID;
                                    lstPeriodTypeStartID_C.forEach(e => {
                                        if(e.value === 1 || e.value === nEndLeaveTimeID){
                                            e.disabled = true;
                                        }else{
                                            e.disabled = false;
                                        }
                                    });
                                    setarrPeriodTypeStartID([...lstPeriodTypeStartID_C]);
                                    form.setValue("sLeaveTypeStart", (isTime ? nEndLeaveTimeID + 1 : nEndLeaveTimeID - 1));
                                    setisErrorDuplicationType(isTime === false);
                                }
                                else if (!isDate)
                                {
                                    let lstPeriodTypeEndID_C = arrPeriodTypeEndID;
                                    lstPeriodTypeEndID_C.forEach(e => {
                                        if(e.value === 1 || e.value === nEndLeaveTimeID){
                                            e.disabled = true;
                                        }else{
                                            e.disabled = false;
                                        }
                                    });
                                    setarrPeriodTypeEndID([...lstPeriodTypeEndID_C]);
                                    form.setValue("sLeaveTypeEnd", (isTime ? nEndLeaveTimeID + 1 : nEndLeaveTimeID - 1));
                                }
                                if(result.objResult.nCalculateDay === 0.5) DialogFn.Warning(result.sMessage);
                                break;
                        }
                    }
                    else {
                        DialogFn.Warning(result.sMessage);
                        setisError(true);
                    }
                }
                else
                {
                    setisError(false);

                    let lstPeriodTypeStartID = arrPeriodTypeStartID;
                    lstPeriodTypeStartID.forEach(e => {e.disabled = false; });
                    setarrPeriodTypeStartID([...lstPeriodTypeStartID]);
                    setisErrorDuplicationType(false);
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                    setisError(true);
                }
            });
        }
        else
        {
            let nTypeID = dEnd != null ? ObjData.sLeaveTypeEnd : ObjData.sLeaveTypeStart;
            let nDeyAll = Convert.StringToInt(ObjLeaveType) === EnumLeaveTypeID.SickLeave ? nSickLeave : nVacationLeave;
            let nDaySum = nTypeID === 1 ? 1 : 0.5;
            setnCalculateDay(nDaySum); //จำนวณวันลาทั้งหมด

            if (nDeyAll < nDaySum) {
                DialogFn.Warning("วันลาคงเหลือไม่เพียงพอ");
                setisError(true);
            } else {
                setisError(false);
            }
        }

        if (dEnd == null) {
            form.setValue("sLeaveTypeEnd", null);
        }

        if (form.watch("sLeaveTypeStart") === "4" && form.watch("dLeaveStartDate")) 
        {
            form.setValue("dLeaveEndDate", null); 
            form.setValue("sLeaveTypeEnd", null);
        }
    }

    const handleBack = () => navigate("/LeaveList");

    const handleSubmit = (e, nModeID: EnumSaveModeLeave) => {
        if (isFileRequired === true && arrFileRequest.length === 0) {
            return DialogFn.Warning(I18n.SetText("UploadFile.sMsgRequiredFile", I18NextNs.labelComponent) + " หลักฐาน/เอกสารแนบ");
        }
        let ObjData = form.getValues();
        let isNotApprovePart = ObjApprover?.isNotApprovePart ?? false;        
        if (ObjData.nApproveID_2 === null || (isNotApprovePart && (ObjData.nApproveID_1 === null || ObjData.nApproveID_1 === 0))) {
            return DialogFn.Warning("กรุณาตรวจสอบข้อมูลผู้อนุมัติ");
        }
        let param = {
            nLeaveID: nLeaveID,
            nSaveModeLeave: nModeID,
            nUserID: nUserID,
            sUser: sUser,
            nLeaveTypeID: ObjData.sLeaveType,
            nLeaveStartDate: ObjData.dLeaveStartDate ? ObjData.dLeaveStartDate.valueOf() : 0,
            nStartLeaveTimeID: ObjData.sLeaveTypeStart,
            nLeaveEndDate: ObjData.dLeaveEndDate ? ObjData.dLeaveEndDate.valueOf() : (ObjData.dLeaveStartDate ? ObjData.dLeaveStartDate.valueOf() : 0),
            nEndLeaveTimeID: ObjData.sLeaveTypeEnd,
            nCalculateDay: nCalculateDay,
            nSickLeave: nSickLeave,
            nVacationLeave: nVacationLeave,
            sAddress: ObjData.sAddress,
            sTelNo: ObjData.sTelNo,
            sDescription: ObjData.sDescription,
            arrFile: arrFileRequest,
            nApproveID_D1: ObjData.nApproveID_1,
            nApproverD1_PositionID : nApproverD1_PositionID,
            isUserActing_D1: isUserActing_D1,
            nApproveID_D2: ObjData.nApproveID_2,
            nApproverD2_PositionID : nApproverD2_PositionID,
            isUserActing_D2: isUserActing_D2,
            
            sLocation: location.pathname,
        };
        DialogFn.Submit(nModeID === EnumSaveModeLeave.Cancel
                        ? I18n.SetText("Message.ConfirmCancel", I18NextNs.labelComponent)
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiLeave.SaveLeave, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(nModeID === EnumSaveModeLeave.Cancel
                        ? I18n.SetText("Message.CancelComplete", I18NextNs.labelComponent)
                        : I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => { handleBack(); });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const handleGetFormLeaveID = (nID) => {
        DialogFn.BlockUI();
        AxiosFn.Get(ApiLeave.GetFormLeaveID, {nLeaveID : nID}, (result) => {
            DialogFn.UnBlockUI();

            setnUserID(result.objResult.nUserID);
            setsUser(result.objResult.sUserName);
            // result.objResult.nOrgID
            form.setValue("sLeaveType", result.objResult.nLeaveTypeID);
            form.setValue("dLeaveStartDate", result.objResult.nStartDate ? moment(result.objResult.nStartDate) : null);
            form.setValue("sLeaveTypeStart", result.objResult.nStartLeaveTimeID);
            if (result.objResult.nStartDate === result.objResult.nEndDate) //กรณีที่วันเดียวกันจะไม่เซต วันสิ้นสุด ให้ ป้องกันซ้ำ
            {
                form.setValue("dLeaveEndDate", null);
                form.setValue("sLeaveTypeEnd", null);
            } else {
                form.setValue("dLeaveEndDate", result.objResult.nEndDate ? moment(result.objResult.nEndDate) : null);
                form.setValue("sLeaveTypeEnd", result.objResult.nEndLeaveTimeID);
            }
            setnCalculateDay(result.objResult.nCalculateDay);
            // setnSickLeave(result.objResult.nSickLeave);
            // setnVacationLeave(result.objResult.nVacationLeave);
            // nUse: `${nDay}.${nHour}`,
            form.setValue("sAddress", result.objResult.sAddress);
            form.setValue("sTelNo", result.objResult.sTelNo);
            form.setValue("sDescription", result.objResult.sDescription);
            setarrFileRequest([...result.objResult.arrFile]);
            setnStatusID(result.objResult.nStatusID);

            //#region Approver
            // setisNotApprovePart(result.objResult.isNotApprovePart);
            // form.setValue("nApproveID_1", result.objResult.nApproveID_D1); //ผอ.ส่วน
            // form.setValue("nApproveID_2", result.objResult.nApproveID_D2); //ผอ.กอง

            // if (result.objResult.nStatusID !== EnumLeaveStatus.Recall_D1 || result.objResult.nStatusID !== EnumLeaveStatus.Recall_D2) {
            //     setisPart(result.objResult.isPart); //ผอ.ส่วน
            //     setisPile(result.objResult.isPile); //ผอ.กอง
            //     setarrUserPartID(result.objResult.lstUserApprovePartID); //ผอ.ส่วน
            //     setarrUserPileID(result.objResult.lstUserApprovePileID); //ผอ.กอง
            // }
            // else if (result.objResult.nStatusID === EnumLeaveStatus.Recall_D1 || result.objResult.nStatusID === EnumLeaveStatus.Recall_D2) {
            //     let _arrApprove_1 = arrUserPartID.filter(f => f.value !== result.objResult.nApproveID_D1) ?? []; //ผอ.ส่วน
            //     let _arrApprove_2 = arrUserPileID.filter(f => f.value !== result.objResult.nApproveID_D2) ?? []; //ผอ.กอง
            //     _arrApprove_1.push(result.objResult.lstUserApprovePartID);
            //     _arrApprove_2.push(result.objResult.lstUserApprovePartID);
            //     setarrUserPartID(_arrApprove_1);
            //     setarrUserPileID(_arrApprove_2);
            // }

            form.setValue("nApproveID_1", result.objResult.nApproveID_D1); //ผอ.ส่วน
            form.setValue("nApproveID_2", result.objResult.nApproveID_D2); //ผอ.กอง

            if ((result.objResult.nStatusID !== EnumLeaveStatus.Recall_D1 && result.objResult.nStatusID !== EnumLeaveStatus.Recall_D2) || !isUserReques) {
                setObjApprover({
                    isNotApprovePart: result.objResult.isNotApprovePart, //กรณีเช็คว่ามี StepFlow ผอ.ส่วน ไหม (True มี | False ไม่มี)
                    isPart: result.objResult.isPart, //ผอ.ส่วน
                    isPile: result.objResult.isPile, //ผอ.กอง
                    arrUserApprove_1: result.objResult.lstUserApprovePartID,
                    arrUserApprove_2: result.objResult.lstUserApprovePileID,
                    nApproverD1_PositionID: result.objResult.nApproverD1_PositionID,
                });
            }
            //#endregion
        });
    };

    return (
        <LeaveContext.Provider
            value={{
                Objform: form,
                nLeaveID: nLeaveID,
                nUserID,
                sUser,
                ObjApprover,
                // //ผอ.ส่วน
                // isNotApprovePart,
                // isPart,
                // arrUserApprove_1 : arrUserPartID,
                // nApproverD1_PositionID,
                // setnApproverD1_PositionID,
                //ผอ.กอง
                // isPile,
                // arrUserApprove_2 : arrUserPileID,
                // nApproverD2_PositionID,
                // setnApproverD2_PositionID,
            }}
        >
            <FormProvider {...form}>
                <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '2%', }}>
                    <Grid item xs={12} md={12} style={{ paddingBottom: '3%', }}>
                        <Grid item className='div-breadcrumbs-Leave'>
                            <Typography variant="h6" style={{ fontSize: 'large', }}>{`${I18n.SetText("Leave.sLeaveFrom")}`}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '3%', padding: '2%'}}>
                        <Grid item xs={12} md={12} container spacing={2} justifyContent="flex-end">
                            <Typography variant="body2" fontWeight="bold" color={'#790103'}>{`${I18n.SetText("Leave.sRequestLeave")}` + "  " + sDate}</Typography>
                        </Grid>
                        <Grid item xs={12} md={12} container spacing={2}>
                            <Grid item><Typography variant="body1" color={'rgba(0, 0, 0, 0.6)'} gutterBottom>{`${I18n.SetText("Leave.sUserName")}`}</Typography></Grid>
                            <Grid item><Typography variant="body1" >{sUser}</Typography></Grid>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <RadioListItem
                                id={"sLeaveType"}
                                name={"sLeaveType"}
                                label={`${I18n.SetText("Leave.sLeaveType")}`}
                                required={true}
                                options={arrLeaveTypeID}
                                disabled={nLeaveID !== 0 || !isPermission}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} container spacing={2}>
                            <Grid item xs={12} md={2.5}>
                                <DatePickerItem
                                    name={"dLeaveStartDate"}
                                    id={"dLeaveStartDate"}
                                    label={`${I18n.SetText("Leave.sLeaveStartDate")}`}
                                    fullWidth={true}
                                    required={true}
                                    disabled={!isPermission}
                                    onDisableDay={(day: Moment) => {
                                        return (day.day() === 0 || day.day() === 6 || arrHoliday.some(a => a.isSame(day)));
                                    }}
                                    minDate={_dStart}
                                    maxDate={_dEnd}
                                    view={["month", "day"]}
                                    IsDisablePortal={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={9.5}>
                                <RadioListItem
                                    id={"sLeaveTypeStart"}
                                    name={"sLeaveTypeStart"}
                                    label={`${I18n.SetText("Leave.sTime")}`}
                                    IsNotShowLabel={true}
                                    required={true}
                                    options={arrPeriodTypeStartID}
                                    disabled={!isPermission}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={12} container spacing={2}>
                            <Grid item xs={12} md={2.5}>
                                <DatePickerItem
                                    name={"dLeaveEndDate"}
                                    id={"dLeaveEndDate"}
                                    label={`${I18n.SetText("Leave.sLeaveEndDate")}`}
                                    fullWidth={true}
                                    required={false}
                                    onDisableDay={(day: Moment) => {
                                        return (day.day() === 0 || day.day() === 6 || arrHoliday.some(a => a.isSame(day)));
                                    }}
                                    minDate={moment(form.watch("dLeaveStartDate"), "DD-MM-YYYY").add('days', 1) || _dStart}
                                    maxDate={_dEnd}
                                    view={["month", "day"]}
                                    // disabled={!form.watch("dLeaveStartDate") || !isPermission || isErrorDuplicationType}
                                    disabled={(form.watch("sLeaveTypeStart") === "4" && form.watch("dLeaveStartDate")) ? true : !form.watch("dLeaveStartDate") || !isPermission || isErrorDuplicationType} //4 8:30 - 12:00 น.
                                    IsDisablePortal={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={9.5}>
                                <RadioListItem
                                    id={"sLeaveTypeEnd"}
                                    name={"sLeaveTypeEnd"}
                                    label={`${I18n.SetText("Leave.sTime")}`}
                                    IsNotShowLabel={true}
                                    required={form.watch("dLeaveEndDate") ? true : false}
                                    options={arrPeriodTypeEndID}
                                    // disabled={!form.watch("dLeaveEndDate") || !isPermission || isErrorDuplicationType}
                                    disabled={(form.watch("sLeaveTypeStart") === "4" && form.watch("dLeaveStartDate")) ? true : !form.watch("dLeaveEndDate") || !isPermission || isErrorDuplicationType} //4 8:30 - 12:00 น.
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                id={"sAddress"}
                                name={"sAddress"}
                                label={`${I18n.SetText("Leave.sDuringLeaveContactAt")}`}
                                required={false}
                                maxLength={250}
                                row={3}
                                disabled={!isPermission}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextBoxItem
                                id={"sTelNo"}
                                name={"sTelNo"}
                                type={"text"}
                                label={`${I18n.SetText("Leave.sTelNo")}`}
                                required={false}
                                maxLength={10}
                                disabled={!isPermission}
                                isTelNo={true}
                                pattern={'en-number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                id={"sDescription"}
                                name={"sDescription"}
                                label={`${I18n.SetText("Leave.sReasonForLeave")}`}
                                required={true}
                                maxLength={250}
                                row={3}
                                disabled={!isPermission}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} style={{ paddingBottom: '3%', }}>
                            <UploadFileItem
                                id="sGalleryFile"
                                name={"sGalleryFile"}
                                label={`${I18n.SetText("Leave.sEvidenceDocuments")}`}
                                required={isFileRequired}
                                arrFile={arrFileRequest}
                                setarrFile={setarrFileRequest}
                                sFolderTemp="Leave"
                                IsFolder={true}
                                IsMultiple={true}
                                // Extension={[...Extension.PDF,Extension.Image_New,Extension.Word,Extension.Other]}
                                Extension={["pdf","jpg", "jpeg", "png", "doc", "docx", "rar", "zip"]}
                                nLimitFile={30}
                                sLimitFile={"MB"}
                                onClearFile={onClearImportFile}
                                sPositionText="right"
                                IsCrop={false}
                                cropMovable={false}
                                cropResize={false}
                                cropShape="retangle"
                                modeDisplay="list"
                                disabled={!isPermission}
                                // IsMultiDelete={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} style={{ paddingBottom: '2%', }}>
                            <StepFlow />
                        </Grid>
                        {/* <Grid item xs={12} md={12} container spacing={1} justifyContent="flex-start">
                            <Grid item xs={3} md={3}>
                                <BtnBack id={"btnBack"} onClick={() => handleBack()} />
                            </Grid>
                            <Grid item xs={9} md={9} container spacing={1} justifyContent="flex-end">
                                {nLeaveID !== 0 ?
                                    <Fragment>
                                        <Grid item>
                                            <BtnReject id={"btnReject"} txt={"ยกเลิกคำขอ"} onClick={form.handleSubmit((e) => handleSubmit(e, EnumStatusFlowLeave.Reject),(err) => console.log("err", err))} />
                                        </Grid>
                                        <Grid item>
                                            <BtnSave id={"btnSave"} onClick={form.handleSubmit((e) => handleSubmit(e, EnumStatusFlowLeave.SendRequest),(err) => console.log("err", err))} />
                                        </Grid>
                                    </Fragment>
                                    :
                                    <Grid item>
                                        <BtnSend id={"btnSend"} txt={"ส่งคำขอ"} onClick={form.handleSubmit((e) => handleSubmit(e, EnumStatusFlowLeave.SendRequest),(err) => console.log("err", err))} />
                                    </Grid>
                                }
                            </Grid>
                        </Grid> */}
                        <Grid item xs={12} md={12} container spacing={1} justifyContent="center">
                            <Grid item>
                                <BtnBack id={"btnBack"} onClick={() => handleBack()} />
                            </Grid>
                            {nStatusID !== EnumLeaveStatus.Canceled && (isUserReques || isUserAdmin) ?
                                nLeaveID !== 0 ?
                                    <Fragment>
                                        {(isBtnCancel || isUserAdmin) &&
                                            <Grid item>
                                                <BtnReject id={"btnCancel"} txt={I18n.SetText("Button.CancelReques", I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => handleSubmit(e, EnumSaveModeLeave.Cancel),(err) => console.log("err", err))} />
                                            </Grid>
                                        }
                                        {isPermission && (nStatusID === EnumLeaveStatus.Recall_D1 || nStatusID === EnumLeaveStatus.Recall_D2) &&
                                            <Grid item>
                                                {/* <BtnSave id={"btnSave"} onClick={form.handleSubmit((e) => handleSubmit(e, EnumSaveModeLeave.Submit),(err) => console.log("err", err))} /> */}
                                                <BtnSend id={"btnSend"} txt={I18n.SetText("Button.SendRequest", I18NextNs.labelComponent)}  IsDisabled={isError} onClick={form.handleSubmit((e) => handleSubmit(e, EnumSaveModeLeave.Submit),(err) => console.log("err", err))} />
                                            </Grid>
                                        }
                                    </Fragment>
                                    :
                                    <Grid item>
                                        <BtnSend id={"btnSend"} txt={I18n.SetText("Button.SendRequest", I18NextNs.labelComponent)}  IsDisabled={isError} onClick={form.handleSubmit((e) => handleSubmit(e, EnumSaveModeLeave.Submit),(err) => console.log("err", err))} />
                                    </Grid>
                                :
                                <></>
                            }
                        </Grid>
                    </Grid>
                    <LogHistory nRefID={nLeaveID} nMode={EnumLogHistoryMode.Leave}/>
                </Grid>
            </FormProvider>
        </LeaveContext.Provider>
    )
}
export default LeaveFrom;
export { LeaveContext };